module.exports = __webpack_public_path__ + "img/tu01.051a765d.png";